var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-other-payment-form" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-web font-weight-bold",
        attrs: { disabled: _vm.disabled, type: "button" },
        on: { click: _vm.handleClick }
      },
      [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("apps.pos.button.enterpaidsuccess", {
                number: _vm.currencyFormatter(_vm.total, { code: _vm.currency })
              })
            )
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71098828", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71098828","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/OtherPaymentForm.vue
// module id = null
// module chunks = 